import { memo } from "react";
import { Link } from "../../../Link";

import { ReactComponent as ExportIcon } from "./icons/export.svg";

type ClearFiltersProps = {
  isVisible: boolean,
  onClick: () => void,
  className?: string
};
export default memo<ClearFiltersProps>((
  {
    isVisible,
    onClick,
    className,
  }) =>
  isVisible ? (
    <Link
      className={className}
      component="button"
      type="button"
      linkType="s"
      onClick={onClick}>
      <ExportIcon width={15} height={15} /> Export to Excel
    </Link>
  ) : null,
);
